import React from "react"
import { useDLScrollObserver } from "./utils/hooks"

export const WatcherDL = () => {
  // Необходимо указать ВСЕ компоненты и задать им нужный ID на родителя компонента, подробнее в DLScrollEvent
  useDLScrollObserver({
    ids: [
      "footer",
      "benefits",
      "calculator",
      "formPkw",
      "form",
      "calculatorRefin",
      "banner",
      "tax_deduction",
      "switcher_content",
      "faq",
      "halva_desyatka",
      "promo",
      "reviews",
    ],
  })

  return <></>
}
